import api from 'api';
import { getCountryOfUser } from 'helpers/userHelper';
import {
  updateAuthStatus,
  setSessionLoadingStatus,
} from 'actions/session';
import { updateWorkflowAsyncSuccess } from 'actions/workflows';
import { updateUserBrandsSuccess } from 'actions/user-brands';

export const USER_REGISTER_ASYNC_ACTION_START = 'USER_REGISTER_ASYNC_ACTION_START';
export const USER_REGISTER_ASYNC_ACTION_ERROR = 'USER_REGISTER_ASYNC_ACTION_ERROR';
export const USER_REGISTER_ASYNC_ACTION_SUCCESS = 'USER_REGISTER_ASYNC_ACTION_SUCCESS';
export const USER_ASYNC_ACTION_START = 'USER_UPDATE_ASYNC_ACTION_START';
export const USER_ASYNC_ACTION_ERROR = 'USER_UPDATE_ASYNC_ACTION_ERROR';
export const USER_UPDATE_ACTION_SUCCESS = 'USER_UPDATE_ACTION_SUCCESS';
export const USER_UPDATE_ACTION = 'USER_UPDATE_ACTION';
export const USER_UPDATE_ACTION_ERROR = 'USER_UPDATE_ACTION_ERROR';
export const RESET_PASSWORD_ASYNC_ACTION_START = 'RESET_PASSWORD_ASYNC_ACTION_START';
export const RESET_PASSWORD_ASYNC_ACTION_ERROR = 'RESET_PASSWORD_ASYNC_ACTION_ERROR';
export const RESET_PASSWORD_ASYNC_ACTION_SUCCESS = 'RESET_PASSWORD_ASYNC_ACTION_SUCCESS';
export const USER_RESET_STATE = 'USER_RESET_STATE';
export const USER_VALIDATION_LEGAL_ACTION_SUCCESS = 'USER_VALIDATION_LEGAL_ACTION_SUCCESS';
export const MFA_ASYNC_ACTION_START = 'MFA_ASYNC_ACTION_START';
export const MFA_ASYNC_ACTION_ERROR = 'MFA_ASYNC_ACTION_ERROR';
export const MFA_ASYNC_ACTION_SUCCESS = 'MFA_ASYNC_ACTION_SUCCESS';


function registerAsyncStart() {
  return {
    type: USER_REGISTER_ASYNC_ACTION_START,
  };
}

function registerAsyncSuccess() {
  return {
    type: USER_REGISTER_ASYNC_ACTION_SUCCESS,
  };
}

function registerAsyncError(error) {
  return {
    type: USER_REGISTER_ASYNC_ACTION_ERROR,
    error,
  };
}

export function userAsyncStart() {
  return {
    type: USER_ASYNC_ACTION_START,
  };
}

function userAsyncError(error) {
  return {
    type: USER_ASYNC_ACTION_ERROR,
    error,
  };
}

function resetPasswordStart() {
  return {
    type: RESET_PASSWORD_ASYNC_ACTION_START,
  };
}

function resetPasswordError(error) {
  return {
    type: RESET_PASSWORD_ASYNC_ACTION_ERROR,
    error,
  };
}

function resetPasswordSuccess() {
  return {
    type: RESET_PASSWORD_ASYNC_ACTION_SUCCESS,
  };
}

export function resetUserState() {
  return {
    type: USER_RESET_STATE,
  };
}

export function updateUserSuccess(data) {
  // add 'country' attribute to the user object
  const country = getCountryOfUser(data.opcoId);
  return {
    type: USER_UPDATE_ACTION_SUCCESS,
    data: { ...data, country },
  };
}

export function updateUserError(error) {
  return {
    type: USER_UPDATE_ACTION_ERROR,
    error,
  };
}

export function updateUser(data) {
  return {
    type: USER_UPDATE_ACTION,
    data,
  };
}

function mfaAsyncStart() {
  return {
    type: MFA_ASYNC_ACTION_START,
  };
}

function mfaAsyncSuccess() {
  return {
    type: MFA_ASYNC_ACTION_SUCCESS,
  };
}

function mfaAsyncError(error) {
  return {
    type: MFA_ASYNC_ACTION_ERROR,
    error,
  };
}

function updateUserValidationLegalSuccess(data) {
  // add 'country' attribute to the user object
  const country = getCountryOfUser(data.opcoId);
  return {
    type: USER_VALIDATION_LEGAL_ACTION_SUCCESS,
    data: { ...data, country },
  };
}

export function updateUserAsync(user) {
  return (dispatch, getState) => {
    dispatch(userAsyncStart());
    return api.request('user', 'put', user)
    .then((data) => {
      dispatch(updateUserSuccess(data));
    })
    .catch((err) => {
      dispatch(userAsyncError('Unable to update account'));
      throw (err.message);
    });
  };
}

export function registerUser(user) {
  return (dispatch) => {
    dispatch(registerAsyncStart());
    return api.request('user', 'post', user)
    .then(() => {
      dispatch(registerAsyncSuccess());
    })
    .catch((err) => {
      dispatch(registerAsyncError(err.message));
      throw (err);
    });
  };
}

export function resetPassword(payload) {
  return (dispatch) => {
    dispatch(resetPasswordStart());
    return api.request('user/resetPwd', 'post', payload)
    .then(() => {
      dispatch(resetPasswordSuccess());
    })
    .catch((err) => {
      dispatch(resetPasswordError('Unable to reset password.'));
      throw (err);
    });
  };
}

export function updateValidationLegalState() {
  return(dispatch, getState) => {
    
    dispatch(userAsyncStart());
    return api.request('user/agreeToLegalTerm', 'put')
    .then((data) => {
      dispatch(updateUserValidationLegalSuccess(data));
    })
    .catch((err) => {
      dispatch(userAsyncError('Unable to update validation legal'));
      throw (err.message);
    })
  }
}

/**
 * Fetch current user details
 * @param {String} accountId accountId if exists. eg: '067-000018'
 * @returns promise
 */
export function getCurrentUserDetails(accountId) {
  const customerHeader = accountId ? { 'X-Opco-Account': accountId } : {};

  return (dispatch) => {
    dispatch(userAsyncStart());
    dispatch(setSessionLoadingStatus(true));
    return api.request('user/current', 'get', null, null, null, null, customerHeader)
      .then((data) => {
        dispatch(updateUserSuccess(data.user));
        dispatch(updateWorkflowAsyncSuccess(data.workflow));
        dispatch(updateUserBrandsSuccess(data.brands));
        dispatch(updateAuthStatus(true));
        return data;
      })
      .catch((err) => {
        dispatch(updateUserError('Unable to get user details'));
        dispatch(setSessionLoadingStatus(false));
        throw (err);
      });
  };
}

export function updateMfaAlertedStatus(payload) {
  return (dispatch) => {
    dispatch(mfaAsyncStart());
    return api
      .request("user/mfaAlertFlag", "post", payload)
      .then(() => {
        dispatch(mfaAsyncSuccess());
      })
      .catch((err) => {
        dispatch(mfaAsyncError(err.message));
        throw err;
      });
  };
}
